import HttpClientToken from '../../services/HttpClientToken';

import { defaultObjetoExhorto, ObjetoExhortoProps } from '../../interfaces/catalogos/ObjetoExhortoInterface';

export const ObjetoExhorto = () => {

    return new Promise<ObjetoExhortoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/ObjetoExhorto/', token)
            .then( ({ data } : { data : ObjetoExhortoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerObjetoExhorto = () => {

    return new Promise<ObjetoExhortoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/ObjetoExhorto/ObtenerObjetoExhorto', token)
            .then( ({ data } : { data : ObjetoExhortoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarObjetoExhorto = ( params: ObjetoExhortoProps ) => {

    return new Promise<ObjetoExhortoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ObjetoExhorto/Actualizar', params, token)
            .then( ({ data } : { data : ObjetoExhortoProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultObjetoExhorto } );
            });

        }

    });

}

export const AgregarObjetoExhorto = ( params: ObjetoExhortoProps ) => {

    return new Promise<ObjetoExhortoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ObjetoExhorto/Agregar', params, token)
            .then( ({ data } : { data : ObjetoExhortoProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultObjetoExhorto } );
            });

        }

    });

}
